import React from 'react';
import './button.css';

const Button = (props) => {
    return (
        <button
            className={props.color}
            onClick={props.onClick}
        >
            {props.type}
        </button>
    );
}

export default Button;